import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/crm/sales-order/{id}/return-to-preparing`。
 * SHIPPING → PREPARING。body：`reason`、`updatedAt`。
 */
export async function returnSalesOrderToPreparing(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/return-to-preparing`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
